import { Overrides } from '@material-ui/core/styles/overrides'

import { masmovilLink, llamayaLink } from './colors'
import { fonts } from './fonts'

import { deepMerge } from '../../utils'

const linkOverride: Overrides = {
  MuiLink: {
    root: {
      fontFamily: fonts.primary,
      fontSize: fonts.size.small,
      fontWeight: 'bold',
      letterSpacing: '0.4px',
      color: masmovilLink.main,
      '&.MuiLink-underlineNone': {
        textTransform: 'uppercase',
      },
    },
  },
}

export const masmovilLinkOverride: Overrides = deepMerge(linkOverride, {
  MuiLink: {
    root: {
      '&.MuiLink-underlineNone': {
        color: masmovilLink.main,
      },
      '&.MuiLink-underlineAlways': {
        color: masmovilLink.main,
      },
    },
  },
})

export const llamayaLinkOverride: Overrides = deepMerge(linkOverride, {
  MuiLink: {
    root: {
      '&.MuiLink-underlineNone': {
        color: llamayaLink.main,
      },
      '&.MuiLink-underlineAlways': {
        color: llamayaLink.main,
      },
    },
  },
})
